import { useEffect } from 'react';
import type { SetState } from 'shared/src/types';
import type { ScreensMetaResponse } from 'shared/src/api';

type UseSetDropdownNavigatorProps = {
  setDropdownNavigator?: SetState<
    ScreensMetaResponse['screen']['dropdown_navigator'] | null
  >;
  dropdownNavigator:
    | ScreensMetaResponse['screen']['dropdown_navigator']
    | undefined;
};

/**
 * meta API에서 받은 dropdown_navigator 데이터를 상위 컴포넌트로 전달합니다.
 */
export const useSetDropdownNavigator = ({
  setDropdownNavigator,
  dropdownNavigator,
}: UseSetDropdownNavigatorProps) => {
  useEffect(() => {
    setDropdownNavigator?.(dropdownNavigator ?? null);
  }, [dropdownNavigator, setDropdownNavigator]);
};
